import React, {useEffect, useState} from 'react';
import './contactUs.css'
import {Col, Container, Row} from "react-bootstrap";
import AOS from 'aos';
import 'aos/dist/aos.css';
import CustomButton from "../../components/accesories/customBtn/CustomButton";
import ReCAPTCHA from "react-google-recaptcha";
import PageHeader from "../../layouts/home/PageHeader";
import {toast} from "react-toastify";
import apiRequest from "../../services/Axios/Configs/configs";
import {useRef} from 'react';
import {useData} from "../../context/DataContext";

function ContactUs(props) {
    const [isNotAbleToSend, setIsNotAbleToSend] = useState(true);
    const [formData, setFormData] = useState({subject: '', name: '', email: '', comment: ''})
    const recaptchaRef = useRef(null);
    const {data,fetchData} = useData();
    const [contactUsData, setContactUsData] = useState([])
    const [recaptchaToken, setRecaptchaToken] = useState('');


    useEffect(() => {
        if (data.contact_us.length === 0) {
            fetchData("contact_us", "contact-us/");
        }
    }, []); // فقط یک بار هنگام mount شدن
    useEffect(() => {
        if (data.contact_us.length > 0) {
            setContactUsData(data.contact_us);
        }
    }, [data.contact_us]); // هر وقت داده عوض شد

    useEffect(() => {
        AOS.init({
            duration: 1000,
            easing: 'ease-in-out', // نوع انیمیشن
            once: true, // فقط یک‌بار انیمیشن اجرا شود
        });
    }, []);

    const recaptchaHandler = (value) => {
        if (value) {
            console.log('recaptcah value:', value)
            setRecaptchaToken(value);
            setIsNotAbleToSend(false);

        }
    }

    const fillForm = (target) => {
        setFormData((prev) => ({
            ...prev,
            [target.name]: target.value
        }));
    };


    const sendHandler = () => {
        if (formData.name.trim() && formData.comment.trim() && formData.subject.trim() && formData.email.trim() && !isNotAbleToSend) {
            apiRequest.post('/message/create/', {
                name: formData.name,
                email: formData.email,
                subject: formData.subject,
                comment: formData.comment,
                recaptcha: recaptchaToken,
            }, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .then(response => {
                    toast.success('پیام شما با موفقیت ارسال شد');
                    setFormData({subject: '', name: '', email: '', comment: ''})
                    setIsNotAbleToSend(true); //
                    recaptchaRef.current?.reset();// دوباره غیرفعال کردن دکمه تا وقتی reCAPTCHA زده نشه
                })
                .catch(error => {
                    console.error(error);
                });
        } else {
            toast.warn('لطفا تمامی مقادیر را پر کنید')
        }
    }
    return (
        <>
            <PageHeader mainTitle={'سوالی داشتی از ما بپرس'} currentPage={'تماس با ما'}
                        navigationLinks={[{title: 'صفحه اصلی', href: '/'}]}/>

            <Container className={'contact-us-content mb-5'}>
                <Row>
                    <Col sm={12} lg={5} className={'ms-auto'}>
                        <div className={'description mb-5'}>
                            {
                                contactUsData.length > 0 &&
                                <p>{contactUsData[0].description}</p>
                            }
                        </div>
                        <div data-aos="flip-up" className={'element-wrapper mb-3 p-3'}>
                            <div className="f-icon-s p-3 rounded" data-bg-color="#d0faec"
                                 style={{backgroundColor: "rgb(208, 250, 236)"}}>
                                <i className="flaticon-location"></i>
                            </div>
                            <div className={'content-wrapper'}>
                                <h4>
                                    آدرس:
                                </h4>
                                {
                                    contactUsData.length > 0 &&
                                    <p>{contactUsData[0].address}</p>
                                }
                            </div>
                        </div>
                        <div data-aos="flip-up" className={'element-wrapper mb-3 p-3'}>
                            <div className="f-icon-s p-3 rounded" data-bg-color="#d0faec"
                                 style={{backgroundColor: "rgb(208, 250, 236)"}}>
                                <i className="flaticon-mail"></i>
                            </div>
                            <div className={'content-wrapper'}>
                                <h4>
                                    ایمیل:
                                </h4>
                                {
                                    contactUsData.length > 0 &&
                                    <a className="btn-link"
                                       href={`mailto:${contactUsData[0].email}`}>{contactUsData[0].email}</a>
                                }
                            </div>
                        </div>

                        <div data-aos="flip-up" className={'element-wrapper mb-3 p-3'}>
                            <div className="f-icon-s p-3 rounded" data-bg-color="#d0faec"
                                 style={{backgroundColor: "rgb(208, 250, 236)"}}>
                                <i className="flaticon-telephone"></i>
                            </div>
                            <div className={'content-wrapper'}>
                                <h4>
                                    تلفن:
                                </h4>
                                {contactUsData.length > 0 &&
                                    <a className="text-dark h6"
                                       href={`tel:${contactUsData[0].phone_number}`}>{contactUsData[0].phone_number}</a>

                                }
                            </div>
                        </div>

                    </Col>
                    <Col sm={12} lg={6} className={'left-col mt-md-5 mt-lg-0'}>
                        <h3>سوالتو با فرم زیر برای ما بفرست
                        </h3>
                        <p>
                            خیلی زود پاسخ سوالتو میدیم
                        </p>
                        <Row>
                            <Col sm={12}>
                                <input type="text" placeholder={'موضوع'} name={'subject'} value={formData.subject}
                                       onChange={e => fillForm(e.target)}/>
                            </Col>
                            <Col sm={12} lg={6}>
                                <input type="text" placeholder={'نام'} name={'name'} value={formData.name}
                                       onChange={e => fillForm(e.target)}/>
                            </Col>
                            <Col sm={12} lg={6}>
                                <input type="text" placeholder={'ایمیل'} name={'email'} value={formData.email}
                                       onChange={e => fillForm(e.target)}/>
                            </Col>
                            <Col sm={12}>
                                <textarea rows={8} placeholder={'نظر شما'} name={'comment'} value={formData.comment}
                                          onChange={e => fillForm(e.target)}/>
                            </Col>
                            <Col sm={12} lg={6} className={'mt-5'}>
                                <CustomButton text={'ارسال پیام'} height={'3rem'} isDisabled={isNotAbleToSend}
                                              buttonClicked={sendHandler}/>
                            </Col>
                            <Col sm={12} lg={6} className={'mt-5'}>
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey="6Ld-sRsrAAAAACtsvksUSqJUv0g70CXywvbabvp6"
                                    onChange={recaptchaHandler}
                                />
                            </Col>

                        </Row>
                    </Col>
                </Row>
            </Container>
        </>

    );
}

export default ContactUs;